import _extends from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Represents Contact Us.
 * @author kkum
 */import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import styles from './Book.style';
import { formLabels, formErrorMessages, BookFormServices } from '../../../constants/labels/en';
import { sendEmail } from '../../../utils/formUtility';
import analyticsConstants from '../../../constants/analyticsConstants';
import Form from '../Form';
import Button from '../../atoms/Button';
import Heading from '../../atoms/Heading';
import ReCaptcha from '../../molecules/ReCaptcha';
import { formsCaptchaActions } from '../../../constants/globalConstants';
var BookForm = /*#__PURE__*/function (_Component) {
  _inherits(BookForm, _Component);
  var _super = _createSuper(BookForm);
  function BookForm(props) {
    var _this;
    _classCallCheck(this, BookForm);
    _this = _super.call(this, props);
    _this.submitBookForm = _this.submitBookForm.bind(_assertThisInitialized(_this));
    _this.successCallback = _this.successCallback.bind(_assertThisInitialized(_this));
    _this.failureCallback = _this.failureCallback.bind(_assertThisInitialized(_this));
    _this.saveCaptchaToken = _this.saveCaptchaToken.bind(_assertThisInitialized(_this));
    _this.state = {
      isSuccessfulSubmission: false,
      errorEmailSending: false,
      captchaToken: ''
    };
    return _this;
  }
  _createClass(BookForm, [{
    key: "successCallback",
    value: function successCallback() {
      this.setState({
        isSuccessfulSubmission: true
      });
    }
  }, {
    key: "failureCallback",
    value: function failureCallback() {
      this.setState({
        errorEmailSending: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var element = document.getElementById('submit-response');
      if (element) {
        element.scrollIntoView();
      }
    }
  }, {
    key: "submitBookForm",
    value: function submitBookForm(values) {
      sendEmail(values, this.props.bookFormData.submitUrl, this.state.captchaToken, this.successCallback, this.failureCallback);
    }
  }, {
    key: "saveCaptchaToken",
    value: function saveCaptchaToken(captchaToken) {
      this.setState(function () {
        return {
          captchaToken: captchaToken
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var userFormProps = {
        initialValues: {
          name: '',
          address: '',
          phone: '',
          secondaryphone: '',
          email: '',
          petname: '',
          checkindate: new Date(),
          emergencyname: '',
          emergencynumber: '',
          isexisitingclient: 'Yes',
          interstedin: 'Training',
          sourceofknowledge: '',
          notes: ''
        },
        action: this.props.bookFormData.submitUrl,
        method: 'POST',
        acceptCharset: 'UTF-8',
        validationSchema: ['name', 'address', 'phone', 'secondaryphone', 'email', 'petname', 'emergencyname', 'emergencynumber', 'checkindate'],
        handleSubmit: this.submitBookForm
      };
      var userFormNameInputProps = {
        name: 'name',
        type: 'text',
        label: formLabels.BookForm.NAME,
        id: 'name',
        ariaLabel: 'Name'
      };
      var userFormAddressInputProps = {
        name: 'address',
        type: 'text',
        label: formLabels.BookForm.ADDRESS,
        id: 'address',
        ariaLabel: 'address'
      };
      var userFormPhoneProps = {
        type: 'text',
        name: 'phone',
        label: formLabels.BookForm.PHONE,
        id: 'phone',
        ariaLabel: 'Phone'
      };
      var userFormSecondaryPhoneProps = {
        name: 'secondaryphone',
        type: 'text',
        label: formLabels.BookForm.SECONDARY_PHONE,
        id: 'secondaryphone',
        ariaLabel: 'secondary phone'
      };
      var userFormEmailProps = {
        type: 'email',
        name: 'email',
        label: formLabels.BookForm.EMAIL,
        id: 'email',
        ariaLabel: 'Email'
      };
      var userFormPetNameProps = {
        type: 'text',
        name: 'petname',
        label: formLabels.BookForm.PETS_NAME,
        id: 'petname',
        ariaLabel: 'pet name'
      };
      var userFormCheckInDateProps = {
        name: 'checkindate',
        className: 'checkin-date',
        label: formLabels.BookForm.CHECKIN_DATE,
        id: 'checkindate',
        startDate: this.props.bookFormData.date ? new Date(this.props.bookFormData.date) : new Date(),
        ariaLabel: 'check in date'
      };
      var userFormEmergencyNameProps = {
        type: 'text',
        name: 'emergencyname',
        label: formLabels.BookForm.EMERGENCY_CONTACT_NAME,
        id: 'emergencyname',
        ariaLabel: 'emergency contact name'
      };
      var userFormEmergencyNumberProps = {
        type: 'text',
        name: 'emergencynumber',
        label: formLabels.BookForm.EMERGENCY_CONTACT_NUMBER,
        id: 'emergencynumber',
        ariaLabel: 'emergency contact number'
      };
      var userFormIsExisitingClientProps = {
        component: 'select',
        options: [{
          value: 'yes',
          label: 'Yes'
        }, {
          value: 'no',
          label: 'No'
        }],
        name: 'isexisitingclient',
        label: formLabels.BookForm.IS_EXISTING_CLIENT,
        id: 'isexisitingclient',
        ariaLabel: 'are you an existing client'
      };
      var userFormInterestedInProps = {
        component: 'select',
        options: BookFormServices,
        name: 'interstedin',
        label: formLabels.BookForm.INTERESTED_SERVICE,
        id: 'interstedin',
        ariaLabel: 'what services are you interested in?'
      };
      var userFormSourceOfKnowledgeProps = {
        type: 'text',
        name: 'sourceofknowledge',
        label: formLabels.BookForm.SOURCE_OF_KNOWLEDGE,
        id: 'sourceofknowledge',
        ariaLabel: 'how did you hear about us'
      };
      var userFormNotesProps = {
        name: 'notes',
        label: formLabels.BookForm.NOTES,
        id: 'notes',
        ariaLabel: 'notes'
      };
      if (this.state.isSuccessfulSubmission) {
        return __jsx("div", {
          className: "nva-book__form-submit-message ".concat(this.props.className),
          id: "submit-response"
        }, __jsx(Heading, {
          HeadingType: "h3",
          className: "nva-book__form-success-message success-message"
        }, this.props.bookFormData.successfulSubmissionMessage));
      }
      if (this.state.errorEmailSending || this.props.forceErrorEmailSending) {
        return __jsx("div", {
          className: "nva-book__form-submit-message ".concat(this.props.className),
          id: "submit-response"
        }, __jsx(Heading, {
          HeadingType: "h4",
          className: "nva-book__form-error-message error-message"
        }, formErrorMessages.BookForm.EMAIL_SEND_ERROR));
      }
      return __jsx("div", {
        className: "nva-book ".concat(this.props.className, " col-sm-10 col-md-8")
      }, __jsx(Form, _extends({}, userFormProps, {
        className: "nva-book__form"
      }), __jsx(Fragment, null, __jsx("div", null, __jsx(Form.Input, _extends({}, userFormNameInputProps, {
        className: "nva-book__form-name-input"
      })), __jsx(Form.Input, _extends({}, userFormAddressInputProps, {
        className: "nva-book__form-address-input"
      })), __jsx(Form.Input, _extends({}, userFormPhoneProps, {
        className: "nva-book__form-phone-input col-md-6 half-left"
      })), __jsx(Form.Input, _extends({}, userFormSecondaryPhoneProps, {
        className: "nva-book__form-secondary-phone-input col-md-6 half-right"
      })), __jsx(Form.Input, _extends({}, userFormEmailProps, {
        className: "nva-book__form-email-input"
      })), __jsx(Form.Input, _extends({}, userFormPetNameProps, {
        className: "nva-book__form-pet-name-input"
      })), __jsx(Form.Date, _extends({}, userFormCheckInDateProps, {
        className: "nva-book__form-check-id-date"
      })), __jsx(Form.Input, _extends({}, userFormEmergencyNameProps, {
        className: "nva-book__form-emergency-name-input col-md-6 half-left"
      })), __jsx(Form.Input, _extends({}, userFormEmergencyNumberProps, {
        className: "nva-book__form-emergency-number-input col-md-6 half-right"
      })), __jsx(Form.Select, _extends({}, userFormIsExisitingClientProps, {
        className: "nva-book__form-existing-client-select col-md-6 half-left"
      })), __jsx(Form.Select, _extends({}, userFormInterestedInProps, {
        className: "nva-book__form-interest-select col-md-6 half-right"
      })), __jsx(Form.Input, _extends({}, userFormSourceOfKnowledgeProps, {
        className: "nva-book__source-knowledge-input"
      })), __jsx(Form.TextArea, _extends({}, userFormNotesProps, {
        className: "nva-book__form-notes-text-area"
      }))), __jsx(Button, {
        className: "nva-book__form-submit-button",
        styleType: "primary",
        type: "submit",
        "data-analytics-type": analyticsConstants.bookForm.analyticsType.BOOK_FORM_TYPE,
        "data-analytics-value": analyticsConstants.bookForm.analyticsValue.BOOK_FORM_VALUE,
        "data-analytics-variation": ""
      }, "Submit")), __jsx(ReCaptcha, {
        className: "nva-book__captcha",
        action: formsCaptchaActions.bookReservationForm,
        siteKey: this.props.bookFormData.reCaptchaKey,
        saveToken: this.saveCaptchaToken
      })));
    }
  }]);
  return BookForm;
}(Component);
BookForm.defaultProps = {
  className: ''
};
export default styled(BookForm).withConfig({
  componentId: "sc-1p3rht2-0"
})(["", ";"], styles);